import { RootState, RootActions } from "common/reducers";
import { List, Record } from "immutable";
import { OneLookLocationRecord, fromJSON } from "common/records/OneLookLocation";
import { RECEIVE_ONE_LOOK_LOCATIONS, SET_LOADING } from "common/reducers/oneLook.actions";

export const OneLookStateRecord = Record({
  locations: List<OneLookLocationRecord>(),
  loading: false,
});

export const initialState = OneLookStateRecord();
export type OneLookState = typeof initialState;

const model = "oneLook";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }

  switch (action.type) {
    case RECEIVE_ONE_LOOK_LOCATIONS: {
      const locations = action.payload;
      return state.setIn([model, "locations"], List(locations.map(fromJSON)));
    }

    case SET_LOADING: {
      const loading = action.payload;
      return state.setIn([model, "loading"], loading);
    }

    default:
      return state;
  }
};
